/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AdminThreadsControllerFindAllQueryResponse, AdminThreadsControllerFindAllQueryParams } from "../../models/adminThreadsController/AdminThreadsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { adminThreadsControllerFindAll } from "../../clients/admin-threadsService/adminThreadsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const adminThreadsControllerFindAllQueryKey = (params: AdminThreadsControllerFindAllQueryParams) => [{
  url: '/api/v1/admin/threads'
}, ...(params ? [params] : [])] as const;
export type AdminThreadsControllerFindAllQueryKey = ReturnType<typeof adminThreadsControllerFindAllQueryKey>;
export function adminThreadsControllerFindAllQueryOptions(params: AdminThreadsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = adminThreadsControllerFindAllQueryKey(params);
  return queryOptions<AdminThreadsControllerFindAllQueryResponse, ResponseErrorConfig<Error>, AdminThreadsControllerFindAllQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return adminThreadsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List a user’s Project Assist threads for customer debugging
 * {@link /api/v1/admin/threads}
 */
export function useAdminThreadsControllerFindAll<TData = AdminThreadsControllerFindAllQueryResponse, TQueryData = AdminThreadsControllerFindAllQueryResponse, TQueryKey extends QueryKey = AdminThreadsControllerFindAllQueryKey>(params: AdminThreadsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<AdminThreadsControllerFindAllQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? adminThreadsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...adminThreadsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}